// React
import React from 'react';
import {useState} from 'react';

// MUI
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import {AdvancedSection} from './AdvancedSection';

function setTimeToday(hhmmss) {
    if (!hhmmss) return null;
    const parts = hhmmss.split(':');
    const h = Number(parts[0]);
    const m = Number(parts[1]);
    const s = Number(parts[2]);
    if (Number.isNaN(h) || Number.isNaN(m) || Number.isNaN(s)) return null;
    const d = new Date();
    d.setHours(h, m, s, 0);
    return d;
}

function utcSecondsToLocalHhmmss(sec) {
    let local = sec - new Date().getTimezoneOffset() * 60;
    local = ((local % 86400) + 86400) % 86400;
    const hh = String(Math.floor(local / 3600)).padStart(2, '0');
    const mm = String(Math.floor((local % 3600) / 60)).padStart(2, '0');
    const ss = String(local % 60).padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
}

export default function DailyProperties(props) {
    const fb = props.node.fb;
    const [startStr, setStartStr] = useState(() => {
        if (fb.triggerTimeOfDay_s != null) return utcSecondsToLocalHhmmss(fb.triggerTimeOfDay_s);
        return '08:00:00';
    });
    const [endStr, setEndStr] = useState(() => {
        if (fb.triggerTimeOfDay_s != null && fb.duration_s != null) {
            const endSec = (fb.triggerTimeOfDay_s + fb.duration_s) % 86400;
            return utcSecondsToLocalHhmmss(endSec);
        }
        return '20:00:00';
    });
    const [, setRefresh] = useState(fb.refreshInterval_s ?? 1);
    const [, setDelayedStart] = useState(fb.delayedStart ?? 0);

    function applyChange(newStartStr, newEndStr) {
        const startD = setTimeToday(newStartStr);
        const endD = setTimeToday(newEndStr);
        if (!startD || !endD) return;
        const startUtcSec = Math.floor(startD.getTime() / 1000) % 86400;
        const endUtcSec = Math.floor(endD.getTime() / 1000) % 86400;
        let durationS = endUtcSec - startUtcSec;
        if (durationS < 0) durationS += 86400;
        if (durationS === 0) durationS = 86400;
        fb.triggerTimeOfDay_s = startUtcSec;
        fb.duration_s = durationS;
        props.changeFunc(props.node);
    }
    function handleStartChange(e) {
        const v = e.target.value;
        setStartStr(v);
        applyChange(v, endStr);
    }
    function handleEndChange(e) {
        const v = e.target.value;
        setEndStr(v);
        applyChange(startStr, v);
    }
    function handleRefreshChange(e) {
        fb.refreshInterval_s = e.target.valueAsNumber;
        setRefresh(e.target.value);
        props.changeFunc(props.node);
    }
    function handleDelayedStartChange(e) {
        fb.delayedStart = e.target.valueAsNumber;
        setDelayedStart(e.target.value);
        props.changeFunc(props.node);
    }
    return (
        <Box sx={{display:'flex', flexDirection:'column', padding:2}}>
            <TextField label="Start" type="time" value={startStr} step={1} InputLabelProps={{shrink:true}} inputProps={{ step: 1 }} onChange={handleStartChange}/>
            <TextField label="End" type="time" value={endStr} step={1} InputLabelProps={{shrink:true}} inputProps={{ step: 1 }} onChange={handleEndChange}/>
            <Typography variant="caption" sx={{mt:1, color:'text.secondary'}}>
                Times are in your browser's local timezone and stored as UTC. Window repeats daily; days under a different DST offset may shift ~1h.
            </Typography>
            <AdvancedSection>
                <TextField label="Refresh interval" value={fb.refreshInterval_s ?? 1} helperText="seconds" type="number" onChange={handleRefreshChange}/>
                <TextField label="Delayed start" value={fb.delayedStart ?? 0} helperText="seconds" type="number" onChange={handleDelayedStartChange}/>
            </AdvancedSection>
        </Box>
    )
};

export {DailyProperties};
export const DailyPropertiesExtension = {triggerTimeOfDay_s:28800, duration_s:43200, refreshInterval_s:1, delayedStart:0};
